import {defineStore} from "pinia";
import {useAppStore as appStore} from '@/store'
import i18n from "@/locales/i18n";
import APIRequest from "@/libs/cloud_auth";

export const EPAPER_RES_IDS = [10, 9, 8];
export const STANDARD_RES_IDS = [1, 2, 3, 4];
export const DEFAULT_EPAPER_RES_ID = 10;
export const DEFAULT_STANDARD_RES_ID = 2;

export const usePresentStore = defineStore("present", {
    state: () => ({
        isLoading: false,
        group_folders: [
            {
                id: true,
                name: i18n.global.t('presentation.shared'),
            },
            {
                id: false,
                name: i18n.global.t('presentation.drafts'),
            },
        ],
        local_folders: [
            {
                id: 'published',
                name: i18n.global.t('players.published'),
            },
            {
                id: 'backup',
                name: i18n.global.t('presentation.drafts'),
            },
        ],
        resolutions: [
            { id: 1, name: 'HD', width: 1280, height: 720},  
            { id: 2, name: 'Full HD', width: 1920, height: 1080},
            { id: 3, name: '2K', width: 2560, height: 1440},
            { id: 4, name: '4K', width: 3840, height: 2160},
            
            // EPAPER
            { id: 8, name: 'E-Paper (Small)', width: 400, height: 300 },
            { id: 9, name: 'E-Paper (Medium)', width: 800 , height: 600 },
            { id: 10, name: 'E-Paper (Large)', width: 1600, height: 1200 },

            { id: 5, name: 'LG Ultra Stretch', width: 3840, height: 600},
            { id: 6, name: 'LG Stretch 5K', width: 5120, height: 2160},
            { id: 7, name: 'LG Stretch FHD', width: 1920, height: 540},
        ],
    }),
    getters: {
        getFolders(state) {
            return JSON.parse(JSON.stringify(state.local_folders));
        },
        getGroupFolders(state) {
            return JSON.parse(JSON.stringify(state.group_folders));
        },
    },
    actions: {
        async getLinkedTemplateTenant(template){
            return new Promise((resolve, reject) => {
                APIRequest(`properties/linked-template-tenant/?group_template=${template}`)
                    .then((response) => {
                        resolve(response.data.results);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        async getLinkedTemplates(){
            return new Promise((resolve, reject) => {
                APIRequest(`properties/linked-template-tenant/getLinkedTemplateTenants/`, 'post', {
                    "ncm": appStore().getCurrentTenant
                })
                    .then((response) => {
                        resolve(this.convertToLegacyJson(response.data));
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        async updateLinkedTemplateTenant(template, tenants){
            return new Promise((resolve, reject) => {
                APIRequest(`properties/linked-template-tenant/updateLinkedTemplates/`, 'post',
                {
                    "tenants": tenants,
                    "template": template
                })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        async getPresentationsAPI() {
            return new Promise((resolve, reject) => {
                APIRequest(`compose/presentation/?source_ref_id=${appStore().getCurrentTenant}`, 'GET')
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        async getGroupPresentationsAPI() {
            return new Promise((resolve, reject) => {
                APIRequest(`compose/group-template/list_group_templates/${appStore().getTenantGroup}`)
                    .then((response) => {
                        resolve(this.convertToLegacyJson(response.data));
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        async createGroupPresentationAPI(formData) {
            return new Promise((resolve, reject) => {
                APIRequest(`compose/group-template/`, 'post', formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    }
                })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        async createPresentationAPI(formData) {
            return new Promise((resolve, reject) => {
                APIRequest(`compose/presentation/`, 'post', formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    }
                })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        async editPresentationAPI(id, formData) {
            return new Promise((resolve, reject) => {
                APIRequest(`compose/presentation/${id}/`, 'patch', formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    }
                })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        async editGroupPresentationAPI(id, formData) {
            return new Promise((resolve, reject) => {
                APIRequest(`compose/group-template/${id}/`, 'patch', formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    }
                })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        async deletePresentationAPI(id) {
            // this.presentations_demo = this.presentations_demo.filter(item => !ids.includes(item.id))
            return new Promise((resolve, reject) => {
                APIRequest(`compose/presentation/${id}/`, 'delete')
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        async deleteGroupPresentationAPI(id) {
            // this.presentations_demo = this.presentations_demo.filter(item => !ids.includes(item.id))
            return new Promise((resolve, reject) => {
                APIRequest(`compose/group-template/${id}/`, 'delete')
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        async duplicatePresentation(presentation_id){
            return new Promise((resolve, reject) => {
              const url = `compose/presentation/duplicate_presentation/`;
              APIRequest(url, 'post' , {id: presentation_id})
                .then(response => {
                  // Resolve the Promise with the response data
                  resolve(response.data);
                })
                .catch(error => {
                  // Reject the Promise with the error
                  reject(error);
                });
              });
          },
        async duplicateGroupPresentation(presentation_id){
            return new Promise((resolve, reject) => {
              const url = `compose/group-template/duplicate_group_template/`;
              APIRequest(url, 'post' , {id: presentation_id})
                .then(response => {
                  // Resolve the Promise with the response data
                  resolve(response.data);
                })
                .catch(error => {
                  // Reject the Promise with the error
                  reject(error);
                });
              });
        },
        renamePresentationAPI(id, name) {
            return new Promise((resolve, reject) => {
                let formData = new FormData();
                formData.append('name', name);

                APIRequest(`compose/presentation/${id}/`, 'post', formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        }
                    })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        setThumbnail(id, thumbnail) {
            const presentation = this.presentations_demo.find(presentation => presentation.id === id);
            if (presentation) {
                presentation.thumbnail = thumbnail;
            }
        },
        createPresentationToTenants(group_template, ncm_ids) {
            return new Promise((resolve, reject) => {
                APIRequest(`compose/group-template/create_presentations/`, 'post',{
                    group_template,
                    ncm_ids
                })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        convertToLegacyJson(presentation) {
            if (!Array.isArray(presentation)) {
                throw new Error('Input must be an array');
            }
            
            return presentation.map(item => ({
                id: item.id,
                template: {
                    id: item.id,
                    thumbnail: `${item.thumbnail}`,
                    json_file_path: `${item.json_file_path}`,
                    created_at: item.created_at,
                    updated_at: item.updated_at,
                    orientation: item.orientation,
                    type: item.type,
                    epaper: item?.epaper || false,
                },
                created_at: item.created_at,
                updated_at: item.updated_at,
                name: item.name,
                slide_amount: item.slide_amount,
                shared: item?.shared,
                width: item?.width,
                height: item?.height
            }));
        }
    },
});
